import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { bool, func, number, shape, string } from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { MIconMenu } from 'library';

// Utils
import { getSelectionURI } from 'utils/helpers/url';

// Components
import { ProductIndicatorBadge } from 'common';

// styles
import { cardBadgeStyles, cardHeaderStyles, cardMenuStyles, titleStyles } from '../Card.styles';

const CardTitle = ({
  authorizationCount,
  cardData,
  currentSelectionNameShort,
  listType,
  setFilters,
  title,
  isProprietaryProduct,
}) => {
  const { currentAffiliateId, dataCompanyId, viewBy } = useParams();
  const navigate = useNavigate();

  const isBaseProduct = isProprietaryProduct === null;
  const theme = useTheme();

  const routeToSupplierAuth = () => {
    const encoded = getSelectionURI(cardData);
    setFilters({ name: 'tempSearchTerm', value: cardData.nameShort });
    const view = viewBy === 'location' ? 'product' : 'location';
    setFilters({
      name: 'tempCardFilter',
      value: { filterBy: viewBy, listType, nameShort: currentSelectionNameShort },
    });
    navigate(
      `/affiliate/${currentAffiliateId}/${dataCompanyId}/loading-management/supplier-authorizations/${view}/${encoded}/`
    );
  };

  const menuItems = [
    {
      label: 'Go to Supplier Authorization',
      onClick: routeToSupplierAuth,
      value: 'on',
    },
  ];

  return (
    <Box sx={cardHeaderStyles}>
      <Typography sx={{ ...titleStyles, fontSize: 16, fontWeight: 'bold' }}>{title}</Typography>
      {!isBaseProduct && (
        <ProductIndicatorBadge proprietary={isProprietaryProduct} sx={cardBadgeStyles} />
      )}
      {!!authorizationCount && (
        <Box sx={cardMenuStyles(theme)}>
          <MIconMenu items={menuItems} />
        </Box>
      )}
    </Box>
  );
};

CardTitle.propTypes = {
  authorizationCount: number,
  cardData: shape({}),
  currentSelectionNameShort: string.isRequired,
  isProprietaryProduct: bool,
  listType: string,
  setFilters: func.isRequired,
  title: string,
};

CardTitle.defaultProps = {
  authorizationCount: null,
  cardData: {},
  isProprietaryProduct: null,
  listType: null,
  title: '',
};

export default CardTitle;
